// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BankInfo_wrapper__3FjP_"};